
namespace GeniuzPOS.InventoryReport {

    @Serenity.Decorators.registerClass()
    export class IcReport01_VDialog extends Serenity.EntityDialog<IcReport01_VRow, any> {
        protected getFormKey() { return IcReport01_VForm.formKey; }
        protected getIdProperty() { return IcReport01_VRow.idProperty; }
        protected getLocalTextPrefix() { return IcReport01_VRow.localTextPrefix; }
        protected getNameProperty() { return IcReport01_VRow.nameProperty; }
        protected getService() { return IcReport01_VService.baseUrl; }
        protected getDeletePermission() { return IcReport01_VRow.deletePermission; }
        protected getInsertPermission() { return IcReport01_VRow.insertPermission; }
        protected getUpdatePermission() { return IcReport01_VRow.updatePermission; }

        protected form = new IcReport01_VForm(this.idPrefix);
        protected getToolbarButtons(): Serenity.ToolButton[] {
            let buttons = super.getToolbarButtons();

            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "save-and-close-button"), 1);
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "apply-changes-button"), 1);
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "delete-button"), 1);

            return buttons;
        }
    }
}